import React, { useState, useEffect } from "react";
import {
  Search,
  Download,
  Eye,
  MessageSquare,
  Check,
  X,
  Paperclip,
} from "lucide-react";
import "../styles/AdminDashboard.css";
import SearchIcon from "@mui/icons-material/Search";
import apiClient from "../api/axiosClient";
import { downloadFile } from "../common";
import { Navigate, useNavigate } from "react-router-dom";
const AdminDashboard = () => {
  const [applications, setApplications] = useState([]);
  const [Registration, setRegistration] = useState([]);

  const [categories, setCategories] = useState([]);
  const [organisations, setOrganisations] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [companyFilter, setCompanyFilter] = useState("All");
  const [visibleCount, setVisibleCount] = useState(12);
  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 12); // show 12 more each time
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get("/vw-form-collection/");
        const data = res.data.results || [];

        // normalize status values
        const normalized = data.map((item) => ({
          ...item,
          status: item.form_mode?.toLowerCase().startsWith("subm") // submit / submitted
            ? "Submitted"
            : item.form_mode?.toLowerCase() === "draft"
            ? "Draft"
            : "Other",
        }));

        setApplications(normalized);

        const uniqueCategories = [
          ...new Set(normalized.map((item) => item.category)),
        ];
        const uniqueOrganisations = [
          ...new Set(normalized.map((item) => item.organisation_name)),
        ];

        setCategories(uniqueCategories);
        setOrganisations(uniqueOrganisations);
      } catch (err) {
        console.error("Error fetching applications:", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get("users/");
        const data = res.data.results || [];

        
        const normalized = data.map((item) => ({
          ...item,
          status: item.form_mode?.toLowerCase().startsWith("subm") // submit / submitted
            ? "Submitted"
            : item.form_mode?.toLowerCase() === "draft"
            ? "Draft"
            : "Other",
        }));

        setRegistration(normalized);

        
      } catch (err) {
        console.error("Error fetching applications:", err);
      }
    };

    fetchData();
  }, []);

  const totalApplications = applications.length;
  const totalRegistrations = Registration.length;

  const draftCount = applications.filter((a) => a.status === "Draft").length;
  const submittedCount = applications.filter(
    (a) => a.status === "Submitted"
  ).length;

  const awardCategories = [
    { id: 1, name: "Exploration Company of the Year" },
    { id: 2, name: "Oil & Gas Production Company of the Year (< 1 MMTOE)" },
    { id: 3, name: "Oil & Gas Production Company of the Year (>= 1 MMTOE)" },
    { id: 4, name: "Goal Net Zero Company of the Year" },
    { id: 5, name: "Green Hydrogen Company of the Year" },
    { id: 6, name: "Overseas Oil & Gas Company of the Year" },
    { id: 7, name: "Digital Technology Provider of the Year" },
    { id: 8, name: "Service Provider of the Year" },
    { id: 9, name: "Pipeline Transportation Company of the Year" },
    { id: 10, name: "Oil Marketing Company of the Year" },
    { id: 11, name: "Human Resource Management " },
    { id: 12, name: "CBG Company of the Year" },
    { id: 13, name: "CGD Company of the Year" },
    { id: 14, name: "Best Managed Project of the Year" },
    { id: 15, name: "Refinery of the Year" },
    { id: 16, name: "Woman Executive of the Year" },
    { id: 17, name: "Young Achiever of the Year (Female)" },
    { id: 18, name: "Young Achiever of the Year (Male)" },
    { id: 19, name: "Innovator of the Year (Team)" },
  ];

  const ORGANISATION_OPTIONS = [
    "Adani Welspun Exploration Limited",
    "ASAP Fluids Private Limited",
    "Axens India (P) Limited",
    "Baker Hughes",
    "Bharat Petroleum Corp. Limited",
    "Bliss Anand Private Limited",
    "BP Exploration (Alpha) Limited",
    "Cairn Oil & Gas, Vedanta Limited",
    "Central U.P. Gas Limited",
    "Chennai Petroleum Corp. Limited",
    "Dynamic Drilling & Services Pvt. Limited",
    "Engineers India Limited",
    "Ernst & Young LLP",
    "ExxonMobil Gas (India) Pvt. Limited",
    "FMC Technologies India Private Limited",
    "GAIL (India) Limited",
    "Goa Natural Gas Private Limited",
    "GSPC LNG Limited",
    "Hindustan Petroleum Corporation Limited",
    "HPCL-Mittal Energy Limited",

    "IMC Limited",
    "Indian Gas Exchange Limited",
    "Indian Oil Corporation Limited",
    "Indian Strategic Petroleum Reserves Limited",
    "IndianOil Adani Ventures Limited",
    "Indraprastha Gas Limited",
    "Indradhanush Gas Grid Limited",
    "IRM Energy Private Limited",
    "Jindal Drilling & Industries Limited",
    "LanzaTech Private Limited",
    "Larsen & Toubro Ltd.",
    "Mangalore Refinery & Petrochemicals Limited",
    "Marine Solutionz Ship Management Private Limited",
    "Nayara Energy Limited",
    "Numaligarh Refinery Limited",
    "Oil & Natural Gas Corporation Limited",
    "Oil India Limited",
    "Petronet LNG Limited",
    "Petronet MHB Limited",
    "Pipeline Infrastructure Limited",
    "Reliance BP Mobility Limited",
    "Reliance Industries Limited",
    "S&P Global Commodity Insights",
    "Seros Energy Private Limited",
    "Shell Companies in India",
    "Siemens Limited",
    "SLB",
    "South Asia Gas Enterprise Pvt. Limited",
    "Sun Petrochemicals Private Limited",
    "THINK Gas Distribution Pvt. Ltd.",
    "Topso A/S",
    "TotalEnergies Gas & Power Projects India Pvt. Ltd.",
    "VCS Quality Services Private Limited",
    "Other",
  ];

  const supportTeam = [
    {
      id: 1,
      name: "Shijo Sebastian",
      email: "fipiawards@fipi.org.in",
      phone: "011 40886021, 011 40886017",
      role: "Support",
    },
  ];

  const filteredApplications = applications.filter((app) => {
    const matchesSearch =
      app.organisation_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.applicant_name?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus = statusFilter === "All" || app.status === statusFilter;
    const matchesCategory =
      categoryFilter === "All" || app.category === categoryFilter;
    const matchesCompany =
      companyFilter === "All" || app.organisation_name === companyFilter;

    return matchesSearch && matchesStatus && matchesCategory && matchesCompany;
  });

  const navigate = useNavigate();
  const handleEyeClick = () => {
    setCompanyFilter("All");
    setStatusFilter("All");
    setCategoryFilter("All");
  };
  const handledraftclick = () => {
    setStatusFilter("Draft");
  };
  const handlesubmitclick = () => {
    setStatusFilter("Submitted");
  };

  const handlexport = () => {
    if (
      categoryFilter === "Oil & Gas Production Company of the Year (< 1 MMTOE)"
    ) {
      navigate("/ExcelProdless");
    } else if (
      categoryFilter === "Oil & Gas Production Company of the Year (>= 1 MMTOE)"
    ) {
      navigate("/ExcelProdmore");
    } else if (categoryFilter === "Refinery of the Year") {
      navigate("/ExcelRefinery");
    } else if (categoryFilter === "Goal Net Zero Company of the Year") {
      navigate("/ExcelGNZ");
    }  else if (
      categoryFilter === "Human Resource Management Company of the Year"
    ) {
      navigate("/ExcelModifier");
    } else if (categoryFilter === "Digital Technology Provider of the Year") {
      navigate("/ExcelDigital");
    
    } else if (categoryFilter === "Exploration Company of the Year") {
      navigate("/ExcelExploration");
    } 
     else if (categoryFilter === "Oil Marketing Company of the Year") {
      navigate("/ExcelOM");
    } 
     else if (categoryFilter === "Pipeline Transportation Company of the Year") {
      navigate("/ExcelPipeline");
    } 
     else if (categoryFilter === "Service Provider of the Year") {
      navigate("/ExcelSP");
    } 
     else if (categoryFilter === "CGD Company of the Year") {
      navigate("/ExcelCGD");
    } 
     else if (categoryFilter === "Green Hydrogen Company of the Year") {
      navigate("/ExcelGH");
    } 
     else if (categoryFilter === "CBG Company of the Year") {
      navigate("/ExcelCBG");
    } 
     else if (categoryFilter === "Best Managed Project of the Year") {
      navigate("/ExcelBMP");
    } 
     else if (categoryFilter === "Overseas Oil & Gas Company of the Year") {
      navigate("/ExcelOverseas");
    } else {
      alert("Export not available for this category yet!");
    }
  };
  

  function handleDownload(mode = "attachments" | "signature", data) {
    const totalAttachments = 4;
    try {
      if (mode === "signature" && data?.approving_authority_file) {
        downloadFile(data.approving_authority_file);
      } else if (mode === "signature" && !data?.approving_authority_file) {
        alert(`Authority file not uploaded.`);
      }

      if (mode === "attachments") {
        const attachments = [];
        // prepare of attachments
        for (let i = 1; i <= totalAttachments; i++) {
          const attachment = data[`attachments${i}`];
          if (attachment) {
            attachments.push(attachment);
            downloadFile(attachment);
          }
        }
        if (attachments.length === 0) {
          alert(`Attachments files not uploaded.`);
        }
      }
    } catch (error) {
      throw new Error(`unexpected Error :: ${error}`);
    }
  }

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Admin Panel</h1>
        <p className="dashboard-subtitle">
          The Federation of Indian Petroleum Industry (FIPI)
        </p>
      </div>
      <div className="kpi-gridd grid grid-cols-4">
        <div className="kpi-card card">
          <div className="kpi-content">
            <div className="kpi-info">
              <p className="kpi-label">Total Applications</p>
              <p className="kpi-value">{totalApplications}</p>
            </div>

            <div className="kpi-icon primary" onClick={() => handleEyeClick()}>
              <Eye size={24} />
            </div>
          </div>
          <div className="kpi-trend">
            <span className="trend-positive">All Categories</span>
          </div>
        </div>

        <div className="kpi-card card">
          <div className="kpi-content">
            <div className="kpi-info">
              <p className="kpi-label">Submitted</p>
              <p className="kpi-value success">{submittedCount}</p>
            </div>
            <div
              className="kpi-icon success"
              onClick={() => handlesubmitclick()}
            >
              <Check size={24} />
            </div>
          </div>
          <div className="kpi-trend">
            <span className="trend-positive"> Submitted Successfully</span>
          </div>
        </div>
        <div className="kpi-card card">
          <div className="kpi-content">
            <div className="kpi-info">
              <p className="kpi-label">Drafts</p>
              <p className="kpi-value warning">{draftCount}</p>
            </div>
            <div
              className="kpi-icon warning"
              onClick={() => handledraftclick()}
            >
              <MessageSquare size={24} />
            </div>
          </div>
          <div className="kpi-trend">
            <span className="trend-warning">Save as Draft</span>
          </div>
        </div>
        <div className="kpi-card card">
          <div className="kpi-content">
            <div className="kpi-info">
              <p className="kpi-label">Total Registrations</p>
              <p className="kpi-value danger">{totalRegistrations}</p>
            </div>
            <div className="kpi-icon danger">
              <Paperclip size={24} />
            </div>
          </div>
          <div className="kpi-trend">
            <span className="trend-negative">Registrations</span>
          </div>
        </div>
      </div>

      <div className="filters-section card">
        <div className="filters-content">
          <div className="search-filters">
            <div className="search-container">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search applicants or organizations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-inputt"
              />
            </div>

            <div className="filter-selects">
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="form-select"
              >
                <option value="All">All Status</option>
                <option value="Draft">Draft</option>
                <option value="Submitted">Submitted</option>
              </select>

              <select
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
                className="form-select"
              >
                <option value="All">All Categories</option>
                {categories.map((category, idx) => (
                  <option key={idx} value={category}>
                    {category}
                  </option>
                ))}
              </select>

              <select
                value={companyFilter}
                onChange={(e) => setCompanyFilter(e.target.value)}
                className="form-select"
              >
                <option value="All">All Companies</option>
                {organisations.map((org, idx) => (
                  <option key={idx} value={org}>
                    {org}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="export-buttons">
            {categoryFilter !== "All" && companyFilter === "All" && (
              <button className="btn btn-success" onClick={() => handlexport()}>
                <Download size={16} />
                Export XLS
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="applications-card-list">
        {filteredApplications.length > 0 ? (
          filteredApplications.slice(0, visibleCount).map((app) => (
            <div key={app.form_id} className="application-card">
              <div className="application-card-header">
                {app.organisation_name}
              </div>
              <p className="para">
                <strong>Category:</strong> {app.category}
                <br />
                <br />
                <strong>Status:</strong>{" "}
                <span
                  className={`application-status ${app.status.toLowerCase()}`}
                >
                  {app.status}
                </span>
                <br />
              </p>
              <div className="application-buttons">
                <button
                  className="application-btn attachment"
                  onClick={() => handleDownload("attachments", app)}
                >
                  <Download size={16} /> Attachments
                </button>
                <button
                  className="application-btn pdf"
                  onClick={() => handleDownload("signature", app)}
                >
                  <Download size={16} /> PDF
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No applications found</p>
        )}
      </div>
      {visibleCount < filteredApplications.length && (
        <div className="show-more-container">
          <button className="show-more-btn end" onClick={handleShowMore}>
            Show More
          </button>
        </div>
      )}

      {/* <div className="applications-section">
        <div className="card">
          <div className="card-header">
            <h2 className="section-title">Award Categories</h2>
          </div>
          <div className="applications-list">
            {awardCategories.map((category) => (
              <div key={category.id} className="application-item">
                <p>{category.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div className="notifications-section">
        <div className="card-support">
          <div className="card-header">
            <h2 className="section-title">Contact Support</h2>
          </div>
          <div className="notifications-list">
            {supportTeam.map((member) => (
              <div key={member.id} className="notification-item">
                <p>
                  <strong>{member.name}</strong> - {member.role}
                </p>
                <p>
                  Email: <a href={`mailto:${member.email}`}>{member.email}</a>
                  <br />
                  Phone:{" "}
                  <a href={`tel:${member.phone.replace(/\s+/g, "")}`}>
                    {member.phone}
                  </a>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
